export const formatPrice = (num: number): string => {
  return (num || 0).toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ",");
};
